import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTranslation, Trans } from "react-i18next";

class Undefined extends Component {
  render() {
    return (
      <Wrapper>
        <h2>404</h2>
        <h3>
          <Trans>pageNotFound</Trans>
        </h3>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 100px;
  font-size: 22px;
  && h2 {
    font-size: 50px;
    padding: 0;
    margin: 0;
  }
`;

const mapStateToProps = () => {
  return {};
};

export default withRouter(
  connect(mapStateToProps)(withTranslation()(Undefined))
);
